/*
 * @Descripttion: 
 * @Author: esther
 * @Date: 2025-11-10 16:09:20
 * @LastEditTime: 2025-11-10 16:26:26
 */
// utils/systemUpdate.js
import axios from 'axios'
import _ from '@/main.js'
console.log('打印数据', _)

export const isNewVersion = () => {
  if (window.location.host.indexOf("localhost") > -1) {
    // 如果是本地环境，无需对比
  } else {
    // 线上环境的version文件请求地址
    let url = "";
    url = `https://${
        window.location.host
      }/version?t=${new Date().getTime()}`;

      const clearCache = () =>{
          // 方案一：清除特定资源缓存
        if ('caches' in window) {
          console.log('清除缓存',window.caches)
          caches.keys()?.length > 0 && caches.keys().then(names => {
            names.forEach(name => caches.delete(name));
          }).then(() => location.reload(true));
        } 
      }

    axios.get(url).then(res => {
      console.log(" ~ file: systemUpdate.js:6 ~ axios.get ~ res", res);
      if (res.status == 200) {
        // 获取version文件最新版本号
        let vueVersion = res.data;

        // 浏览器缓存中获取之前的版本号
        let localVueVersion = window.localStorage.getItem("appVersion");

        if (localVueVersion && localVueVersion != vueVersion) {
          // 版本号不一致，存储新版本号，并刷新浏览器缓存
          window.localStorage.setItem("appVersion", vueVersion);
          // window.location.reload(true);
          localStorage.setItem("needRefrash", true);
          clearCache();

          // _.$forceUpdate();

          // return;
        } else {
          if (!localVueVersion) {
            window.localStorage.setItem("appVersion", vueVersion);
            localStorage.setItem("needRefrash", true);
            // window.location.reload(true);
            clearCache();
            // _.$forceUpdate();
          } else {
            localStorage.setItem("needRefrash", false);
          }
        }
      }
    }).catch((err) => {
      console.log('请求失败', err)
    })
  }
};